import AccountCallback from './pages/Account/Callback/index'
import AccountSignIn from './pages/Account/SignIn/index'
import AccountSorry from './pages/Account/Sorry/index'
import Dashboard from './pages/Dashboard/index'
import Dispatch from './pages/Dispatch/index'
import Policy from './pages/Policy/index'
import PseudoSignIn from './pages/Pseudo/SignIn/index'

export default [
  {
    path: '/account/signin',
    name: 'account_signin',
    component: AccountSignIn
  },
  {
    path: '/account/callback',
    name: 'account_callback',
    component: AccountCallback
  },
  {
    path: '/dispatch',
    name: 'dispatch',
    component: Dispatch,
    meta: { requiresAuth: true, requiresRoles: ['basic'] }
  },
  {
    path: '/login',
    redirect: '/account/signin'
  },
  {
    path: '/signin',
    redirect: '/account/signin'
  },
  {
    path: '/account',
    redirect: '/account/signin'
  },
  {
    path: '/account/sorry',
    name: 'account_sorry',
    component: AccountSorry
  },
  {
    path: '/pseudo/signin',
    name: 'pseudo_signin',
    component: PseudoSignIn
  },
  {
    path: '/',
    redirect: '/dashboard'
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: Dashboard
  },
  {
    path: '/privacypolicy',
    redirect: '/policy'
  },
  {
    path: '/policy',
    name: 'policy',
    component: Policy
  },
  {
    path: '*',
    redirect: '/'
  }
]



// WEBPACK FOOTER //
// ./src/common/routes.js